import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { policesAPI } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import DocsSouscription from './DocsSouscription';
import DateField from '../shared/DateField';
import CollecteInfoGF from './CollecteInfoGF';
import { theme, sectionCardStyle, sectionHeaderRow, sectionTitleStyle, sectionIconWrap, sectionIntroStyle, sectionFooterStyle, primaryButtonStyle, secondaryButtonStyle } from '../../theme';
import SurveillanceRisque from './SurveillanceRisque';
import PaymentGraphGF from './PaymentGraphGF';

const BASE = '/api';
function authFetch(url,opts={}){
  const token=localStorage.getItem('arcus_token');
  return fetch(url,{...opts,headers:{'Content-Type':'application/json',...(opts.headers||{}),...(token?{Authorization:`Bearer ${token}`}:{})}});
}


const STATUTS_STYLE = {
  demande_pieces: { bg:'#FEF3E2', cl:'#9A5A00', dot:'#F18A00' },
  en_cours_etude: { bg:'#EDE9FE', cl:'#5B21B6', dot:'#8B5CF6' },
  devis:      { bg:'#DBEAFE', cl:'#1D4ED8', dot:'#3B82F6' },
  souscrit:   { bg:'#D1FAE5', cl:'#065F46', dot:'#10B981' },
  suspendu:   { bg:'#FEE2E2', cl:'#991B1B', dot:'#EF4444' },
  resilie:    { bg:'#F1F5F9', cl:'#475569', dot:'#94A3B8' },
  sans_objet: { bg:'#F1F5F9', cl:'#94A3B8', dot:'#CBD5E1' },
};
const ORANGE = theme.orange;

const SvgIcon = ({ size = 16, color = 'currentColor', children }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
    {children}
  </svg>
);
const TabIcons = {
  policy:       (c) => (<SvgIcon color={c}><path d="M14 3v4a1 1 0 0 0 1 1h4M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/></SvgIcon>),
  underwriting: (c) => (<SvgIcon color={c}><path d="M9 12l2 2l4 -4M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"/></SvgIcon>),
  souscription: (c) => (<SvgIcon color={c}><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2M9 14l2 2l4 -4"/></SvgIcon>),
  tarification: (c) => (<SvgIcon color={c}><path d="M9 14c0 1.66 2.69 3 6 3s6 -1.34 6 -3M9 14c0 -1.66 2.69 -3 6 -3s6 1.34 6 3M9 14v4c0 1.66 2.69 3 6 3s6 -1.34 6 -3v-4"/></SvgIcon>),
  surveillance: (c) => (<SvgIcon color={c}><path d="M3 12c2 -4 6 -7 9 -7s7 3 9 7c-2 4 -6 7 -9 7s-7 -3 -9 -7M12 9a3 3 0 1 0 0 6a3 3 0 0 0 0 -6"/></SvgIcon>),
  documents:    (c) => (<SvgIcon color={c}><path d="M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"/></SvgIcon>),
  paymentGraph: (c) => (<SvgIcon color={c}><path d="M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1zM9 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1zM15 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1zM4 20h14"/></SvgIcon>),
};
const SLIDE_ICON_GF = ['policy','underwriting','souscription','tarification','surveillance','documents'];

// Icônes de SECTION (style Tabler) pour les cartes internes des slides.
const SectionIconPaths = {
  client:    'M9 7a3 3 0 1 0 6 0a3 3 0 0 0 -6 0M5.5 21a6.5 6.5 0 0 1 13 0',
  type:      'M3 21h18M5 21v-12l7 -4l7 4v12M9 21v-6h6v6',
  status:    'M9 12l2 2l4 -4M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 14a12 12 0 0 0 8.5 -3',
  dates:     'M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2zM16 3v4M8 3v4M4 11h16',
  amount:    'M12 3v18M9 14c0 1.66 1.34 3 3 3s3 -1.34 3 -3s-1.34 -3 -3 -3s-3 -1.34 -3 -3s1.34 -3 3 -3s3 1.34 3 3',
  documents: 'M14 3v4a1 1 0 0 0 1 1h4M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2',
};

// Carte de section uniforme (contour épais + en-tête à icône orange), comme FicheDossier.
const Section = ({ icon, title, intro, right, children, style }) => (
  <div style={{ ...sectionCardStyle, ...(style || {}) }}>
    <div style={sectionHeaderRow}>
      <div style={sectionTitleStyle}>
        {icon && (
          <span style={sectionIconWrap}>
            <SvgIcon size={16} color={ORANGE}><path d={SectionIconPaths[icon] || SectionIconPaths.documents}/></SvgIcon>
          </span>
        )}
        {title}
      </div>
      {right}
    </div>
    {intro && <div style={sectionIntroStyle}>{intro}</div>}
    {children}
  </div>
);

// Icône de document premium : glyphe SVG net dans une tuile arrondie teintée.
const DOC_ICON_PATHS = {
  projet:      { tint:'#EFF6FF', stroke:'#2563EB', d:'M14 3v4a1 1 0 0 0 1 1h4M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2zM9 9h1M9 13h6M9 17h6' },
  police:      { tint:'#F5F3FF', stroke:'#7C3AED', d:'M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2M9 12l2 2l4 -4' },
  cg:          { tint:'#ECFDF5', stroke:'#059669', d:'M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0M3 6v13M12 6v13M21 6v13' },
  attestation: { tint:'#FEF3E2', stroke:'#F18A00', d:'M12 15a5 5 0 1 0 0 -10a5 5 0 0 0 0 10zM8.5 13.5l-1.5 6l5 -3l5 3l-1.5 -6M9.5 10l1.5 1.5l3 -3' },
};
const DocIcon = ({ type }) => {
  const cfg = DOC_ICON_PATHS[type] || DOC_ICON_PATHS.projet;
  return (
    <span style={{ width:40, height:40, borderRadius:10, background:cfg.tint, display:'inline-flex',
      alignItems:'center', justifyContent:'center', flexShrink:0 }}>
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke={cfg.stroke}
        strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d={cfg.d}/></svg>
    </span>
  );
};

const toISO = d => {
  if (!d) return '';
  const s = String(d);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);   // date brute ou préfixe d'un ISO
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;         // pas de new Date → aucun décalage de fuseau
  const dt = new Date(s);
  if (isNaN(dt)) return '';
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
};
// Affichage des dates en lecture : mois en LETTRES (non ambigu).
let CUR_LANG = 'fr';
const DATE_LOCALES = { fr: 'fr-FR', en: 'en-GB', de: 'de-DE', sv: 'sv-SE' };
const fmtFR = d => {
  if (!d) return '\u2014';
  const s = String(d);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const dt = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
    return dt.toLocaleDateString(DATE_LOCALES[CUR_LANG] || 'fr-FR', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });
  }
  const dt = new Date(s);
  return isNaN(dt) ? '\u2014' : dt.toLocaleDateString(DATE_LOCALES[CUR_LANG] || 'fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
};
const fmt2  = n => n!=null ? new Intl.NumberFormat('fr-FR',{minimumFractionDigits:2}).format(parseFloat(n))+' €' : '—';
const lbl   = { fontSize:12, color:'#64748B', display:'block', marginBottom:3, fontWeight:600 };
const inp   = { border:'1px solid #E2E8F0', borderRadius:6, padding:'7px 10px', width:'100%', fontSize:14, boxSizing:'border-box', fontFamily:'inherit' };
const lockedField = { background:'#F8FAFC', border:'1px solid #F1F5F9', borderRadius:6, padding:'7px 10px', fontSize:14, color:'#94A3B8', minHeight:35 };

export default function FicheGF() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, lang } = useLanguage();
  CUR_LANG = lang;
  const { isCourtier, isArcus, isClient, isReadOnly } = useAuth();

  const CONTEXTE_OPTIONS = [
    { v:'creation',       l:t('gf.contexte_creation'),  hint:t('gf.contexte_hint_creation'),  icon:'🆕' },
    { v:'historique',     l:t('gf.contexte_historique'), hint:t('gf.contexte_hint_existant'),  icon:'🏢' },
    { v:'ajout_activite', l:t('gf.contexte_ajout'),      hint:t('gf.contexte_hint_existant'),  icon:'➕' },
  ];
  // Slides définis par id (pour gérer filtrage rôles)
  const SLIDE_DEFS = [
    { id:'policy',        label:t('gf.tab_policy'),          iconKey:'policy' },
    { id:'underwriting',  label:t('gf.tab_underwriting'),    iconKey:'underwriting' },
    { id:'souscription',  label:t('gf.tab_souscription'),    iconKey:'souscription' },
    { id:'payment_graph', label:t('gf.tab_payment_graph'),   iconKey:'paymentGraph', arcusOnly:true },
    { id:'surveillance',  label:t('gf.tab_surveillance'),     iconKey:'surveillance' },
    { id:'documents',     label:t('gf.tab_documents'),        iconKey:'documents' },
  ];
  // arcusOnly : onglet visible uniquement pour les profils Arcus (manager, souscripteur, accounts, IT)
  const SLIDES_VISIBLE = SLIDE_DEFS.filter(s =>
    !(isClient && s.hideForClient) && !(s.arcusOnly && !isArcus));
  const SLIDES = SLIDES_VISIBLE.map(s => s.label);

  const [police, setPolice]           = useState(null);
  const [collecteGF, setCollecteGF]     = useState({});
  const [tarificationGF, setTarificationGF] = useState([]);
  const [surveillanceGF, setSurveillanceGF] = useState({});
  const [paymentGraphGF, setPaymentGraphGF] = useState({});
  const [slide, setSlide]             = useState(0);
  const [saving, setSaving]           = useState(false);
  const [error, setError]             = useState('');
  const [showSouscrire, setShowSouscrire] = useState(false);
  const [souscrireForm, setSouscrireForm] = useState({ date_effet:'', n_police:'', frequency:'trimestrielle' });
  const [souscribing, setSouscribing]     = useState(false);
  const [docsValidation, setDocsValidation] = useState(null);
  const [checkingDocs, setCheckingDocs]     = useState(false);
  // Workflow de soumission GF (courtier/client)
  const [docsSousStatus, setDocsSousStatus] = useState(null); // {allProvided, missingCount, requiredTotal}
  const [showSubmitGf, setShowSubmitGf]     = useState(false);
  const [submittingGf, setSubmittingGf]     = useState(false);
  const [showRepasserConfirm, setShowRepasserConfirm] = useState(false);
  const [repassing, setRepassing]           = useState(false);

  const locked = police && (police.statut === 'souscrit' || police.statut === 'resilie' || police.est_archive);
  // Le client ET le courtier ne peuvent JAMAIS rien modifier dans l'onglet "La Police"
  // (statut, numéros, dates — notamment la date d'effet).
  const allLocked = locked || isCourtier || isClient;
  const isDevis = police?.statut === 'devis';
  // Verrouillage de la SAISIE (collecte + documents) pour le courtier/client :
  // ils ne peuvent remplir/déposer que tant que le dossier est en "Demande de pièces".
  // Une fois soumis ('en_cours_etude') ou au-delà, tout est verrouillé pour eux.
  const gfFillLocked = locked || ((isCourtier || isClient) && police?.statut !== 'demande_pieces');

  // ── Phases du workflow GF ────────────────────────────────────────
  // Étude du dossier : demande_pieces → en_cours_etude → devis (Arcus).
  // La Police : activée uniquement une fois la police souscrite.
  const SUBSCRIBED_STATUTS = ['souscrit', 'resilie', 'suspendu', 'renouvelee', 'sans_objet'];
  const isSubscribed = SUBSCRIBED_STATUTS.includes(police?.statut);
  const isStudy = !!police && !isSubscribed;
  const etudeEditable = isArcus && !isReadOnly && isStudy && !locked;      // section Étude éditable par Arcus
  const datePrevLocked = !etudeEditable || police?.statut === 'devis';     // date prév. figée au passage en devis
  const STUDY_ORDER = ['demande_pieces', 'en_cours_etude', 'devis'];

  useEffect(() => {
    if (!id) return;
    policesAPI.get(id).then(async data => {
      // Auto-correct produit if missing (police created before fix)
      if (data.produit !== 'gf') {
        try { await policesAPI.update(id, { ...data, produit: 'gf' }); }
        catch {}
        data.produit = 'gf';
      }
      setPolice(data);
      if (data.collecte_gf) setCollecteGF(typeof data.collecte_gf === 'string' ? JSON.parse(data.collecte_gf) : data.collecte_gf);
      if (data.tarification_gf) {
        const tgf = typeof data.tarification_gf === 'string' ? JSON.parse(data.tarification_gf) : data.tarification_gf;
        setTarificationGF(Array.isArray(tgf) ? tgf : []);
      }
      if (data.surveillance_gf) {
        const sgf = typeof data.surveillance_gf === 'string' ? JSON.parse(data.surveillance_gf) : data.surveillance_gf;
        setSurveillanceGF(sgf || {});
      }
      if (data.payment_graph_gf) {
        const pg = typeof data.payment_graph_gf === 'string' ? JSON.parse(data.payment_graph_gf) : data.payment_graph_gf;
        setPaymentGraphGF(pg || {});
      }
    }).catch(e => setError(e.message));
  }, [id]);

  function update(field, value) {
    if (allLocked) return;
    setPolice(p => ({ ...p, [field]: value }));
  }

  async function save() {
    setSaving(true); setError('');
    try { await policesAPI.update(id, { ...police, collecte_gf: collecteGF, tarification_gf: tarificationGF, surveillance_gf: surveillanceGF, payment_graph_gf: paymentGraphGF }); }
    catch(e) { setError(e.message); }
    finally { setSaving(false); }
  }

  // Met à jour le Payment Graph ET persiste immédiatement (utilisé pour les
  // actions "engageantes" : génération de cotation, d'appel de prime de variation…).
  async function commitPaymentGraph(newData) {
    setPaymentGraphGF(newData);
    setError('');
    // Passage automatique en 'devis' à la génération du projet d'assurance (cotation).
    // Deux chemins : parcours client classique (en_cours_etude) OU parcours 100 % admin
    // (demande_pieces : l'admin a rempli collecte + pièces + payment graph sans soumission client).
    const bumpDevis = !!newData?.cotation?.generated_at && ['demande_pieces', 'en_cours_etude'].includes(police?.statut);
    const patch = bumpDevis ? { statut: 'devis' } : {};
    try {
      await policesAPI.update(id, { ...police, ...patch, collecte_gf: collecteGF, tarification_gf: tarificationGF, surveillance_gf: surveillanceGF, payment_graph_gf: newData });
      if (bumpDevis) setPolice(p => p ? { ...p, statut: 'devis' } : p);
    }
    catch(e) { setError(e.message); }
  }

  // Persistance IMMÉDIATE de la surveillance (déclaration client / validation Arcus) :
  // sauvegarde la police entière — chiffres saisis inclus — sans passer par « Enregistrer ».
  async function commitSurveillance(newData) {
    setSurveillanceGF(newData);
    setError('');
    try {
      await policesAPI.update(id, { ...police, collecte_gf: collecteGF, tarification_gf: tarificationGF, surveillance_gf: newData, payment_graph_gf: paymentGraphGF });
    }
    catch(e) { setError(e.message); }
  }

  // Ouvre la modale de souscription (après contrôle des pièces requises).
  async function openSouscrire() {
    setCheckingDocs(true);
    try {
      const docs = await authFetch(`/api/polices/${id}/docs-souscription`).then(r => r.json());
      const missing = Array.isArray(docs) ? docs.filter(d => d.requis && d.statut !== 'accepte') : [];
      setDocsValidation({ ok: missing.length === 0, missing });
    } catch {
      setDocsValidation({ ok: true, missing: [] });
    } finally {
      setCheckingDocs(false);
      setSouscrireForm({
        date_effet: toISO(police.date_effet_prev) || '',
        n_police: police.n_police || '',
        frequency: surveillanceGF?.frequency || 'trimestrielle',
      });
      setShowSouscrire(true);
    }
  }

  // Souscription effective : devis → souscrit (date d'effet, n° police, fréquence).
  async function doSouscrire() {
    if (!souscrireForm.date_effet) { setError(t('gf.souscrire_need_date')); return; }
    setSouscribing(true); setError('');
    try {
      const res = await authFetch(`/api/polices/${id}/souscrire-gf`, {
        method: 'POST',
        body: JSON.stringify({
          date_effet: souscrireForm.date_effet,
          n_police: souscrireForm.n_police || null,
          frequency: souscrireForm.frequency,
        }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Erreur'); return; }
      setPolice(data);
      if (data.surveillance_gf) {
        setSurveillanceGF(typeof data.surveillance_gf === 'string' ? JSON.parse(data.surveillance_gf) : (data.surveillance_gf || {}));
      }
      setShowSouscrire(false);
    } catch(e) { setError(e.message); }
    finally { setSouscribing(false); }
  }

  // ── Complétude de la collecte (champs obligatoires) ──────────────
  // 0 est une valeur valable ; seul un champ totalement vide est manquant.
  const isEmpty = v => v === undefined || v === null || String(v).trim() === '';
  const COLLECTE_REQUIRED = [
    ['nom_social',                t('collecte.nom_social')],
    ['directeur',                 t('collecte.directeur')],
    ['adresse',                   t('collecte.adresse')],
    ['code_postal',               t('intermediaires.postal_code')],
    ['ville',                     t('intermediaires.city')],
    ['forme_juridique',           t('collecte.forme_juridique')],
    ['ca_forfaits_distribution',  t('collecte.ca_forfaits_dist')],
    ['ca_forfaits_production',    t('collecte.ca_forfaits_prod')],
    ['ca_prestations',            t('collecte.ca_prestations')],
    ['ca_transport',              t('collecte.ca_transport')],
    ['clientele_btoc',            t('collecte.clientele_btoc')],
    ['clientele_btob',            t('collecte.clientele_btob')],
    ['pct_acompte',               t('collecte.pct_acompte')],
    ['mois_reservation',          t('collecte.mois_reservation')],
    ['mois_solde',                t('collecte.mois_solde')],
    ['montant_moyen_voyageur',    t('collecte.montant_moyen')],
  ];
  const collecteMissing = COLLECTE_REQUIRED.filter(([k]) => isEmpty(collecteGF?.[k])).map(([,label]) => label);
  // Années d'expérience : TOUS les dirigeants listés doivent l'avoir renseignée.
  const dirigeants = Array.isArray(collecteGF?.dirigeants) ? collecteGF.dirigeants : [];
  const dirigeantsExpMissing = dirigeants.length === 0
    ? true
    : dirigeants.some(d => isEmpty(d?.annees_exp));
  if (dirigeantsExpMissing) collecteMissing.push(t('collecte.dir_annees'));
  const collecteComplete = collecteMissing.length === 0;

  // Le courtier/client peut soumettre si la collecte est complète ET tous les
  // documents de souscription requis sont fournis.
  const docsComplete = !!docsSousStatus?.allProvided;
  const canSubmitGf = collecteComplete && docsComplete;

  async function submitGf() {
    setSubmittingGf(true); setError('');
    try {
      // Sauvegarder d'abord la collecte pour ne rien perdre.
      await policesAPI.update(id, { ...police, collecte_gf: collecteGF, tarification_gf: tarificationGF, surveillance_gf: surveillanceGF, payment_graph_gf: paymentGraphGF });
      const res = await authFetch(`/api/polices/${id}/soumettre-gf`, { method:'POST' });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Erreur'); return; }
      setPolice(data);
      setShowSubmitGf(false);
    } catch(e) { setError(e.message); }
    finally { setSubmittingGf(false); }
  }

  // Arcus : « Repasser en Demande de pièces et informations »
  // → en_cours_etude/devis → demande_pieces, déverrouille le formulaire client.
  async function repasserDemandePieces() {
    setRepassing(true); setError('');
    try {
      const res = await authFetch(`/api/polices/${id}/renvoyer-pieces-gf`, { method:'POST' });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Erreur'); return; }
      setPolice(data);
      setShowRepasserConfirm(false);
    } catch(e) { setError(e.message); }
    finally { setRepassing(false); }
  }

  if (!police) return <div style={{padding:24,color:'#64748B'}}>{error||t('common.loading')}</div>;

  const ss = STATUTS_STYLE[police.statut] || STATUTS_STYLE.devis;
  const STATUTS_LABELS = {
    demande_pieces: t('status.demande_pieces'), en_cours_etude: t('status.en_cours_etude'),
    devis: t('status.devis'), souscrit: t('status.souscrit'),
    suspendu: t('status.suspendu'), resilie: t('status.resilie'), sans_objet: t('status.sans_objet'),
  };

  // ── SLIDE 1 — LA POLICE ───────────────────────────────────────
  function renderS1() {
    const STUDY_STEPS = [
      { v:'demande_pieces', l:t('status.demande_pieces'), hint:t('gf.step_hint_demande_pieces'), bg:STATUTS_STYLE.demande_pieces.bg, cl:STATUTS_STYLE.demande_pieces.cl },
      { v:'en_cours_etude', l:t('status.en_cours_etude'), hint:t('gf.step_hint_en_cours'),       bg:STATUTS_STYLE.en_cours_etude.bg, cl:STATUTS_STYLE.en_cours_etude.cl },
      { v:'devis',          l:t('status.devis'),          hint:t('gf.step_hint_devis'),          bg:STATUTS_STYLE.devis.bg,          cl:STATUTS_STYLE.devis.cl },
    ];
    return (
      <div>
        {/* Client */}
        <Section icon="client" title={t('polices.client_readonly')}
          right={<div style={{fontSize:13,color:theme.textSecondary}}>{police.marche_pays} · {police.type_relation==='direct'?t('clients.direct'):t('clients.brokered')}</div>}>
          <div style={{fontSize:16,fontWeight:700,color:theme.text}}>{police.client_nom}</div>
        </Section>

        {/* Contexte de la demande */}
        <Section icon="type" title={t('gf.contexte_label')}>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10}}>
            {CONTEXTE_OPTIONS.map(opt => {
              const selected = police.contexte_gf === opt.v;
              return (
                <button key={opt.v} onClick={() => !locked && update('contexte_gf', opt.v)}
                  disabled={locked}
                  style={{
                    padding:'14px 12px', borderRadius:10, cursor:locked?'default':'pointer',
                    border:`2px solid ${selected?'#E8671A':'#E2E8F0'}`,
                    background:selected?'#FFF7F2':'#fff', textAlign:'left',
                    transition:'all .12s',
                  }}>
                  <div style={{fontSize:22,marginBottom:8}}>{opt.icon}</div>
                  <div style={{fontSize:13,fontWeight:700,color:selected?'#E8671A':'#1A1A1A',marginBottom:4}}>
                    {opt.l}
                  </div>
                  <div style={{fontSize:11,color:'#64748B',lineHeight:1.4}}>{opt.hint}</div>
                </button>
              );
            })}
          </div>
          {!police.contexte_gf && !locked && (
            <div style={{fontSize:12,color:'#DC2626',marginTop:6}}>⚠ {t('gf.contexte_label')}</div>
          )}
        </Section>

        {/* ── Étude du dossier ── */}
        <Section icon="dates" title={t('gf.etude_title')}>
        {isSubscribed && (
          <div style={{background:'#F1F5F9',border:'1px solid #E2E8F0',borderRadius:8,padding:'8px 12px',marginBottom:14,fontSize:12.5,color:'#64748B',display:'flex',alignItems:'center',gap:8}}>
            🔒 {t('gf.etude_locked_note')}
          </div>
        )}
        {/* Numéro de projet */}
        <div style={{maxWidth:340,marginBottom:16}}>
          <label style={lbl}>{t('gf.numero_projet')}</label>
          <div style={lockedField}>{police.n_devis||'—'} <span style={{fontSize:10,color:'#94A3B8',marginLeft:8}}>{t('common.auto_generated')}</span></div>
        </div>
        {/* Stepper des 3 statuts d'étude (non cliquable) */}
        <label style={lbl}>{t('polices.policy_status')}</label>
        <div style={{display:'flex',gap:8,margin:'6px 0 16px',flexWrap:'wrap'}}>
          {STUDY_STEPS.map((step, i) => {
            const curIdx = STUDY_ORDER.indexOf(police.statut);
            const isCurrent = police.statut === step.v;
            const isDone = isSubscribed || (curIdx > i);
            const bg = isCurrent ? step.bg : (isDone ? '#ECFDF5' : '#F8FAFC');
            const bd = isCurrent ? step.cl : (isDone ? '#6EE7B7' : '#E2E8F0');
            const fg = isCurrent ? step.cl : (isDone ? '#065F46' : '#94A3B8');
            return (
              <div key={step.v} style={{flex:'1 1 200px',minWidth:180,border:`1.5px solid ${bd}`,background:bg,borderRadius:10,padding:'10px 12px'}}>
                <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                  <div style={{width:20,height:20,borderRadius:99,background:isCurrent?step.cl:(isDone?'#10B981':'#CBD5E1'),color:'#fff',fontSize:11,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center'}}>
                    {isDone && !isCurrent ? '✓' : i+1}
                  </div>
                  <div style={{fontSize:12.5,fontWeight:700,color:fg}}>{step.l}</div>
                </div>
                <div style={{fontSize:10.5,color:isCurrent?fg:'#94A3B8',lineHeight:1.4,paddingLeft:28}}>{step.hint}</div>
              </div>
            );
          })}
        </div>
        {/* Date d'effet prévisionnelle */}
        <div style={{maxWidth:340,marginBottom:16}}>
          <label style={lbl}>{t('gf.date_effet_prev')}</label>
          {datePrevLocked
            ? <div style={lockedField}>{fmtFR(police.date_effet_prev)}</div>
            : <DateField value={toISO(police.date_effet_prev)} onChange={v=>update('date_effet_prev', v)} style={inp}/>
          }
          {police.statut==='devis' && (
            <div style={{marginTop:6,fontSize:11,color:'#D97706'}}>🔒 {t('gf.date_prev_locked_devis')}</div>
          )}
        </div>
        {/* Actions Étude : repasser (secondaire) + souscrire (principal) */}
        {(etudeEditable && ['en_cours_etude','devis'].includes(police.statut)) || (isArcus && !isReadOnly && police.statut==='devis') ? (
          <div style={{marginTop:16,paddingTop:16,borderTop:'1px solid #E2E8F0',display:'flex',alignItems:'center',gap:12,flexWrap:'wrap',justifyContent:'space-between'}}>
            {etudeEditable && ['en_cours_etude','devis'].includes(police.statut)
              ? <button onClick={()=>setShowRepasserConfirm(true)}
                  style={{fontSize:13,padding:'8px 15px',borderRadius:7,background:'#fff',color:'#C2410C',border:'1px solid #FCD9A6',cursor:'pointer',fontWeight:600}}>
                  ↩ {t('gf.repasser_btn')}
                </button>
              : <span/>}
            {isArcus && !isReadOnly && police.statut==='devis' && (
              <button onClick={openSouscrire} disabled={checkingDocs || !police.contexte_gf}
                style={{fontSize:14,padding:'9px 18px',borderRadius:8,background:'#059669',color:'#fff',border:'none',cursor:(checkingDocs||!police.contexte_gf)?'not-allowed':'pointer',fontWeight:700,opacity:(checkingDocs||!police.contexte_gf)?.6:1,display:'inline-flex',alignItems:'center',gap:8}}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12l2 2l4 -4M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18"/></svg>
                {t('gf.souscrire_btn')}
              </button>
            )}
          </div>
        ) : null}
        </Section>

        {/* ── La Police (activée à la souscription) ── */}
        <Section icon="dates" title={t('polices.tab_policy')}>
        {isStudy && (
          <div style={{background:'#F8FAFC',border:'1px solid #E2E8F0',borderRadius:8,padding:'8px 12px',marginBottom:14,fontSize:12.5,color:'#64748B',display:'flex',alignItems:'center',gap:8}}>
            🔒 {t('gf.police_locked_note')}
          </div>
        )}
        <div style={{opacity:isStudy?.55:1}}>
          {/* Statut — badge lecture seule (aucune modification manuelle) */}
          <div style={{marginBottom:16}}>
            <label style={lbl}>{t('polices.policy_status')}</label>
            <div style={{marginTop:5}}>
              <span style={{display:'inline-flex',alignItems:'center',gap:7,padding:'5px 14px',borderRadius:99,fontSize:13,fontWeight:700,background:ss.bg,color:ss.cl}}>
                <span style={{width:8,height:8,borderRadius:99,background:ss.dot}}/>{STATUTS_LABELS[police.statut]||police.statut}
              </span>
            </div>
          </div>
          {/* N° police + date d'effet définitive */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16}}>
            <div>
              <label style={lbl}>{t('polices.policy_number')}</label>
              <div style={lockedField}>{police.n_police||'—'}</div>
            </div>
            <div>
              <label style={lbl}>{t('polices.effect_date')}</label>
              <div style={lockedField}>{fmtFR(police.date_effet)}</div>
            </div>
          </div>
          {/* Échéance */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div>
              <label style={lbl}>{t('polices.expiry_date')} <span style={{fontSize:10,color:'#94A3B8'}}>{t('polices.expiry_auto')}</span></label>
              <div style={lockedField}>{fmtFR(police.date_echeance)}</div>
            </div>
          </div>
          <div style={{marginTop:10,fontSize:12,color:'#94A3B8'}}>{t('polices.renewal_note')}</div>
        </div>
        </Section>
      </div>
    );
  }

  // ── SLIDE 2 — COLLECTE DES INFORMATIONS ──────────────────────
  function renderS2() {
    return (
      <CollecteInfoGF
        data={collecteGF}
        onChange={setCollecteGF}
        readOnly={gfFillLocked}
      />
    );
  }

  // ── SLIDE 3 — DOCUMENTS ───────────────────────────────────────
  function renderS3() {
    const cotation = paymentGraphGF?.cotation;
    const cotationReady = !!cotation?.generated_at;

    // Ligne de document réutilisable
    const docRow = (doc) => (
      <div key={doc.key} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 13px',border:'1px solid #E2E8F0',borderRadius:8,marginBottom:8,opacity:doc.locked?.4:1,background:'#fff'}}>
        <DocIcon type={doc.iconType || doc.key}/>
        <div style={{flex:1}}>
          <div style={{fontSize:14,fontWeight:700}}>{doc.label}</div>
          <div style={{fontSize:12,color:'#64748B',marginTop:2}}>{doc.desc}</div>
        </div>
        {doc.locked
          ? <span style={{fontSize:11,padding:'3px 9px',borderRadius:99,background:'#F1F5F9',color:'#94A3B8',border:'1px solid #E2E8F0'}}>{doc.lockedLabel||t('common.locked_after_binding')}</span>
          : isArcus ? <button onClick={()=>alert('Template GF à venir')}
              style={{fontSize:13,padding:'5px 13px',borderRadius:6,cursor:'pointer',background:'#1A1A1A',color:'#fff',border:'none',fontWeight:700}}>
              {t('common.download')}
            </button> : <span style={{fontSize:11,color:'#94A3B8'}}>{t('polices.broker_docs_locked')}</span>
        }
      </div>
    );

    const contractuelles = [
      { key:'police',      label:t('polices.doc_policy'),      desc:`${t('polices.policy_number')} · ${police.n_police||'—'}`, locked:isDevis },
      { key:'cg',          label:t('polices.doc_cg'),          desc:'CG-GF-FR template', locked:false },
      { key:'attestation', label:t('polices.doc_attestation'), desc:t('polices.doc_attestation_desc'), locked:isDevis },
    ];

    return (
      <div>
        <div style={{background:'#F8FAFC',borderRadius:7,padding:'9px 13px',marginBottom:14,fontSize:13,display:'flex',alignItems:'center',gap:8}}>
          🌐 {t('polices.doc_language')}
        </div>
        {isDevis && <div style={{background:'#FEF3C7',border:'1px solid #FDE68A',borderRadius:7,padding:'9px 13px',marginBottom:14,fontSize:13,color:'#92400E'}}>
          {t('polices.doc_devis_warning')}
        </div>}

        {/* Projet d'assurance — débloqué par la génération de la cotation (onglet Payment Graph) */}
        <Section icon="documents" title={t('gf.doc_section_projet')}>
          {docRow({
            key:'projet',
            label:t('polices.doc_project'),
            desc: cotationReady ? `${t('gf.doc_projet_ready')} ${fmtFR(cotation.generated_at)} · ${fmt2(cotation.total_ttc)}` : t('gf.doc_projet_locked'),
            locked: !cotationReady,
            lockedLabel: t('gf.doc_projet_badge_todo'),
          })}
        </Section>

        {/* Pièces contractuelles */}
        <Section icon="documents" title={t('gf.doc_section_contractuelles')}>
          {contractuelles.map(docRow)}
        </Section>

        {/* Appels de prime de variation (générés) */}
        {(() => {
          const genVars = Array.isArray(paymentGraphGF?.variations) ? paymentGraphGF.variations.filter(v => v.generated_at) : [];
          if (genVars.length === 0) return null;
          return (
            <Section icon="documents" title={t('gf.doc_section_variations')}>
              {genVars.map(v => docRow({
                key: `var-${v.id}`,
                iconType: 'projet',
                label: `${t('gf.doc_variation_label')} — ${v.period_label}`,
                desc: `${t('gf.doc_projet_ready')} ${fmtFR(v.generated_at)} · ${fmt2(v.total_ttc)}`,
                locked: false,
              }))}
            </Section>
          );
        })()}

        <Section icon="documents" title={t('polices.internal_notes')}>
        <textarea value={police.notes_internes||''} onChange={e=>!locked&&update('notes_internes',e.target.value)}
          readOnly={locked} placeholder={t('polices.notes_placeholder')}
          style={{...inp,minHeight:80,resize:'vertical'}}/>
        </Section>
      </div>
    );
  }

  return (
    <>
      {/* Modal — Repasser en Demande de pièces (Arcus) */}
      {showRepasserConfirm && (
        <div onClick={()=>!repassing&&setShowRepasserConfirm(false)}
          style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1200}}>
          <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:12,padding:24,width:480,maxWidth:'92vw'}}>
            <div style={{fontSize:16,fontWeight:700,marginBottom:8,color:'#1A1A1A'}}>{t('gf.repasser_confirm_title')}</div>
            <div style={{fontSize:13.5,color:'#64748B',lineHeight:1.6,marginBottom:18}}>{t('gf.repasser_confirm_desc')}</div>
            <div style={{display:'flex',justifyContent:'flex-end',gap:10}}>
              <button onClick={()=>setShowRepasserConfirm(false)} disabled={repassing}
                style={{fontSize:14,padding:'8px 16px',borderRadius:8,border:'1px solid #E2E8F0',background:'#fff',cursor:'pointer'}}>{t('common.cancel')}</button>
              <button onClick={repasserDemandePieces} disabled={repassing}
                style={{fontSize:14,padding:'8px 18px',borderRadius:8,background:'#C2410C',color:'#fff',border:'none',cursor:'pointer',fontWeight:700,opacity:repassing?.6:1}}>{t('gf.repasser_confirm_btn')}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de soumission du dossier GF (courtier/client) */}
      {showSubmitGf && (
        <div onClick={()=>!submittingGf && setShowSubmitGf(false)}
          style={{position:'fixed',inset:0,background:'rgba(0,0,0,.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:12,padding:24,width:440,maxWidth:'90vw'}}>
            <div style={{fontSize:16,fontWeight:700,marginBottom:10,color:'#1A1A1A'}}>{t('gf.submit_confirm_title')}</div>
            <div style={{fontSize:13.5,color:'#475569',lineHeight:1.6,marginBottom:18}}>{t('gf.submit_confirm_desc')}</div>
            <div style={{display:'flex',justifyContent:'flex-end',gap:10}}>
              <button onClick={()=>setShowSubmitGf(false)} disabled={submittingGf}
                style={{padding:'8px 16px',borderRadius:8,border:'1px solid #E2E8F0',background:'#fff',cursor:'pointer'}}>
                {t('common.cancel')}
              </button>
              <button onClick={submitGf} disabled={submittingGf}
                style={{padding:'8px 18px',borderRadius:8,border:'none',background:'#F18A00',color:'#fff',fontWeight:700,cursor:submittingGf?'not-allowed':'pointer',opacity:submittingGf?.6:1}}>
                {submittingGf ? t('common.saving') : t('gf.submit_confirm_btn')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal — Souscrire la police (Arcus) */}
      {showSouscrire && (
        <div onClick={()=>!souscribing&&setShowSouscrire(false)} style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1200}}>
          <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:12,padding:24,width:460,maxWidth:'92vw'}}>
            <div style={{fontSize:16,fontWeight:700,marginBottom:6}}>{t('gf.souscrire_confirm_title')}</div>
            <div style={{fontSize:13,color:'#64748B',lineHeight:1.6,marginBottom:16}}>{t('gf.souscrire_confirm_desc')} <strong>{t('common.irreversible')}</strong></div>
            {/* Date d'effet définitive */}
            <div style={{marginBottom:12}}>
              <label style={lbl}>{t('gf.souscrire_date_label')}</label>
              <DateField value={souscrireForm.date_effet} onChange={v=>setSouscrireForm(f=>({...f,date_effet:v}))} style={inp}/>
            </div>
            {/* N° de police */}
            <div style={{marginBottom:12}}>
              <label style={lbl}>{t('gf.souscrire_npolice_label')}</label>
              <input value={souscrireForm.n_police} onChange={e=>setSouscrireForm(f=>({...f,n_police:e.target.value}))} placeholder="Ex. GF-2026-0001" style={inp}/>
            </div>
            {/* Fréquence du monitoring */}
            <div style={{marginBottom:14}}>
              <label style={lbl}>{t('gf.souscrire_freq_label')}</label>
              <div style={{display:'flex',gap:8,marginTop:5}}>
                {[['trimestrielle',t('gf.surveillance_freq_trim')],['semestrielle',t('gf.surveillance_freq_sem')]].map(([v,l])=>(
                  <button key={v} onClick={()=>setSouscrireForm(f=>({...f,frequency:v}))}
                    style={{flex:1,padding:'8px 12px',borderRadius:7,fontSize:13,cursor:'pointer',fontWeight:souscrireForm.frequency===v?700:400,
                      background:souscrireForm.frequency===v?'#161616':'#fff',color:souscrireForm.frequency===v?'#fff':'#64748B',border:souscrireForm.frequency===v?'none':'1px solid #CBD5E1'}}>
                    {l}
                  </button>
                ))}
              </div>
              <div style={{fontSize:11,color:'#94A3B8',marginTop:5}}>{t('gf.souscrire_freq_hint')}</div>
            </div>
            {docsValidation && !docsValidation.ok && (
              <div style={{background:'#FEF3C7',border:'1px solid #FDE68A',borderRadius:7,padding:'10px 14px',marginBottom:14}}>
                <div style={{fontSize:13,fontWeight:700,color:'#92400E',marginBottom:6}}>⚠ {t('polices.confirm_binding_docs_missing')}</div>
                {docsValidation.missing.map((doc,i)=>(
                  <div key={i} style={{fontSize:12.5,color:'#78350F',display:'flex',gap:6,marginBottom:2}}>
                    <span>·</span><span><strong>{doc.nom}</strong> — {doc.statut==='uploade'?t('polices.doc_waiting_approval'):t('polices.doc_not_uploaded')}</span>
                  </div>
                ))}
              </div>
            )}
            {error && <div style={{background:'#FEE2E2',border:'1px solid #FCA5A5',borderRadius:7,padding:'8px 12px',marginBottom:12,fontSize:13,color:'#991B1B'}}>⚠ {error}</div>}
            <div style={{display:'flex',justifyContent:'flex-end',gap:8}}>
              <button onClick={()=>setShowSouscrire(false)} disabled={souscribing} style={{fontSize:14,padding:'8px 16px',borderRadius:8,border:'1px solid #CBD5E1',cursor:'pointer',background:'#fff'}}>{t('common.cancel')}</button>
              <button onClick={doSouscrire} disabled={souscribing || !souscrireForm.date_effet}
                style={{fontSize:14,padding:'8px 18px',borderRadius:8,background:'#059669',color:'#fff',border:'none',cursor:(souscribing||!souscrireForm.date_effet)?'not-allowed':'pointer',fontWeight:700,opacity:(souscribing||!souscrireForm.date_effet)?.5:1}}>
                ✓ {t('gf.souscrire_confirm_btn')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Fiche */}
      <div style={{margin:'0 auto'}}>
        <div style={{background:'#fff',borderRadius:10,border:'1px solid #E2E8F0',overflow:'hidden'}}>
          {/* Header clair (style "Ligne") */}
          <div style={{padding:'16px 20px',borderBottom:`2px solid ${theme.borderDark}`}}>
            <div style={{display:'flex',alignItems:'center',gap:13}}>
              <button onClick={()=>navigate(`/clients/${police.client_id}/detail`)}
                style={{background:theme.surfaceAlt,border:`0.5px solid ${theme.border}`,width:34,height:34,borderRadius:8,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <SvgIcon size={18} color={theme.textSecondary}><path d="M15 6l-6 6l6 6"/></SvgIcon>
              </button>
              <div style={{width:42,height:42,borderRadius:'50%',background:theme.sidebarBg,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <SvgIcon size={22} color={ORANGE}><path d="M3 21l18 0M3 10l18 0M5 6l7 -3l7 3M4 10l0 11M20 10l0 11M8 14l0 3M12 14l0 3M16 14l0 3"/></SvgIcon>
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:11,color:theme.textTertiary,letterSpacing:'.04em',textTransform:'uppercase',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                  {t('gf.title')} · {police.client_nom}
                </div>
                <div style={{fontSize:22,fontWeight:800,color:theme.text,fontFamily:'monospace'}}>
                  {police.n_police||police.n_devis||'—'}
                </div>
              </div>
              <span style={{fontSize:12,padding:'5px 13px',borderRadius:99,background:ss.bg||ss.cl,color:ss.cl,fontWeight:500,flexShrink:0,display:'inline-flex',alignItems:'center',gap:6}}>
                <span style={{width:6,height:6,borderRadius:'50%',background:ss.dot}}></span>
                {STATUTS_LABELS[police.statut]||police.statut}
              </span>
            </div>
          </div>

          {/* Onglets avec icônes */}
          <div style={{display:'flex',borderBottom:'1px solid #F1F5F9',padding:'0 14px',gap:2,flexWrap:'wrap'}}>
            {SLIDES_VISIBLE.map((s,i) => {
              const IconFn = TabIcons[s.iconKey] || TabIcons.policy;
              const active = slide===i;
              return (
                <button key={s.id} onClick={()=>setSlide(i)}
                  style={{padding:'11px 13px',fontSize:13,cursor:'pointer',background:'none',border:'none',
                    color:active?ORANGE:'#64748B',fontWeight:active?500:400,
                    borderBottom:active?`2px solid ${ORANGE}`:'2px solid transparent',
                    display:'flex',alignItems:'center',gap:7}}>
                  {IconFn(active?ORANGE:'#64748B')}
                  {s.label}
                </button>
              );
            })}
          </div>

          {/* Contenu */}
          <div style={{padding:20,minHeight:400}}>
            {isCourtier && (
              <div style={{background:'#EFF6FF',border:'1px solid #BFDBFE',borderRadius:7,
                padding:'8px 12px',marginBottom:14,fontSize:13,color:'#1D4ED8',display:'flex',gap:8}}>
                {t('polices.broker_view_banner')}
              </div>
            )}
            {error && <div style={{background:'#FEE2E2',color:'#991B1B',borderRadius:6,padding:'8px 12px',marginBottom:14,fontSize:14}}>{error}</div>}
            {locked && (
              <div style={{background:'#D1FAE5',border:'1px solid #6EE7B7',borderRadius:7,padding:'8px 12px',marginBottom:14,fontSize:13,color:'#065F46'}}>
                {t('polices.locked_banner')}
              </div>
            )}
            {/* Dossier soumis — en cours d'étude (courtier/client) */}
            {(isCourtier||isClient) && police.statut==='en_cours_etude' && (
              <div style={{background:'#EDE9FE',border:'1px solid #C4B5FD',borderRadius:7,padding:'10px 13px',marginBottom:14,fontSize:13,color:'#5B21B6'}}>
                {t('gf.submitted_banner')}
              </div>
            )}
            {/* Ce qui reste à compléter avant de pouvoir soumettre (courtier/client) */}
            {(isCourtier||isClient) && police.statut==='demande_pieces' && !canSubmitGf && (
              <div style={{background:'#FFF7F2',border:'1px solid #FDD9BF',borderRadius:7,padding:'11px 13px',marginBottom:14}}>
                <div style={{fontSize:12.5,fontWeight:700,color:'#C2410C',marginBottom:6}}>{t('gf.submit_missing_title')}</div>
                {!collecteComplete && (
                  <div style={{marginBottom: docsComplete ? 0 : 6}}>
                    <div style={{fontSize:11.5,fontWeight:600,color:'#7C4A03',marginBottom:3}}>{t('gf.submit_missing_collecte')}</div>
                    <div style={{fontSize:12,color:'#7C4A03'}}>{collecteMissing.slice(0,8).join(' · ')}{collecteMissing.length>8?` … (+${collecteMissing.length-8})`:''}</div>
                  </div>
                )}
                {!docsComplete && (
                  <div style={{fontSize:12,color:'#7C4A03'}}>
                    <span style={{fontWeight:600}}>{t('gf.submit_missing_docs')}</span> {docsSousStatus?.missingCount ? `(${docsSousStatus.missingCount})` : ''}
                  </div>
                )}
              </div>
            )}
            {SLIDES_VISIBLE[slide]?.id === 'policy'       && renderS1()}
            {SLIDES_VISIBLE[slide]?.id === 'underwriting' && renderS2()}
            {SLIDES_VISIBLE[slide]?.id === 'souscription' && <DocsSouscription key={police?.contexte_gf||"creation"} policeId={id} produit="gf" contexte={police?.contexte_gf||"creation"} readOnly={gfFillLocked} locked={gfFillLocked} docsLocked={!!police.docs_souscription_verrouilles} onDocsLockChange={(v)=>setPolice(p=>p?{...p,docs_souscription_verrouilles:v}:p)} onStatusChange={setDocsSousStatus} onPoliceStatut={(st)=>setPolice(p=>p?{...p,statut:st}:p)}/>}
            {SLIDES_VISIBLE[slide]?.id === 'payment_graph' && <PaymentGraphGF collecteGF={collecteGF} data={paymentGraphGF} onChange={setPaymentGraphGF} onCommit={commitPaymentGraph} surveillance={surveillanceGF} readOnly={isReadOnly || police.est_archive || police.statut==='resilie'} subscribed={isSubscribed}/>}
            {SLIDES_VISIBLE[slide]?.id === 'surveillance' && <SurveillanceRisque police={police} collecteGF={collecteGF} surveillance={surveillanceGF} onChange={setSurveillanceGF} onCommit={commitSurveillance} readOnly={isCourtier}/>}
            {SLIDES_VISIBLE[slide]?.id === 'documents'    && renderS3()}
          </div>

          {/* Footer */}
          <div style={{padding:'10px 16px',borderTop:'1px solid #F1F5F9',background:'#FFF7F2',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <button onClick={()=>navigate(`/clients/${police.client_id}/detail`)} style={{fontSize:14,color:'#E8671A',background:'none',border:'none',cursor:'pointer'}}>{t('common.close')}</button>
            <span style={{fontSize:12,color:'#E8671A',opacity:.7}}>{t('common.slide')} {slide+1} / {SLIDES.length}</span>
            <div style={{display:'flex',gap:7}}>
              {slide>0 && <button onClick={()=>setSlide(s=>s-1)} style={{fontSize:14,padding:'7px 15px',borderRadius:6,border:'1px solid #CBD5E1',cursor:'pointer',background:'#fff'}}>{t('common.previous')}</button>}
              {slide<SLIDES.length-1 && <button onClick={()=>setSlide(s=>s+1)} style={{fontSize:14,padding:'7px 15px',borderRadius:6,border:'1px solid #CBD5E1',cursor:'pointer',background:'#fff'}}>{t('common.next')}</button>}
              {!isReadOnly && ((isArcus && (!locked || ['surveillance','policy'].includes(SLIDES_VISIBLE[slide]?.id))) || (isClient && (!locked || SLIDES_VISIBLE[slide]?.id === 'surveillance'))) && <button onClick={save} disabled={saving} style={{fontSize:14,padding:'7px 15px',borderRadius:6,background:'#1A1A1A',color:'#fff',border:'none',cursor:'pointer',fontWeight:700}}>
                {saving?t('common.saving'):'✓ '+t('common.save')}
              </button>}
              {/* Soumission du dossier GF (courtier/client) */}
              {(isCourtier||isClient) && police.statut==='demande_pieces' && <button
                onClick={()=>setShowSubmitGf(true)} disabled={!canSubmitGf}
                title={!canSubmitGf ? t('gf.submit_blocked_hint') : ''}
                style={{fontSize:14,padding:'7px 15px',borderRadius:6,
                  background:canSubmitGf?'#F18A00':'#E2E2DF',color:canSubmitGf?'#fff':'#9A9A95',
                  border:'none',cursor:canSubmitGf?'pointer':'not-allowed',fontWeight:700}}>
                {t('gf.submit_btn')}
              </button>}
              {police.statut==='souscrit' && isArcus && <button onClick={()=>alert(t('common.coming_soon')||'Fonctionnalité à venir')}
                style={{fontSize:14,padding:'7px 15px',borderRadius:8,background:'#2563EB',color:'#fff',border:'none',cursor:'pointer',fontWeight:500}}>
                {t('gf.renew_procedure')}
              </button>}
              {police.statut==='souscrit' && isArcus && <button onClick={()=>alert(t('common.coming_soon')||'Fonctionnalité à venir')}
                style={{fontSize:14,padding:'7px 15px',borderRadius:8,background:'#DC2626',color:'#fff',border:'none',cursor:'pointer',fontWeight:500}}>
                {t('gf.terminate_gf')}
              </button>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
